import colors from 'zignal-landscape/lib/styles/colors.css';
import map from 'lodash/map';

export const HEADER_TEXT = ' Influence Intelligence';
export const HEADER_DESCRIPTION = `
Use this solution to explore social conversations and understand how bots are spreading messages.
`;
export const TEXT_WIDTH_LIMIT = 800;
export const HOVER_TEXT_WIDTH_LIMIT = 2000;

export const SIZE_NODES_BY_OPTIONS = [
  { value: 'influenceScore', label: 'Influence' },
  { value: 'followerCount', label: 'Number of Followers' },
  { value: 'postCount', label: 'Number of Tweets' },
];

const CLUSTER_VIEW_BY_OPTIONS = [
  {
    value: 'entities',
    label: 'Entities',
    searchPattern: (discoverSearch) => {
      return discoverSearch;
    },
    isKeywordSearchEnabled: false
  },
  {
    value: 'issues',
    label: 'Tags',
    searchPattern: null,
    isKeywordSearchEnabled: false,
    enableFilter: true
  },
  {
    value: 'hashtags',
    label: 'Hashtags',
    searchPattern: (discoverSearch) => {
      return encodeURIComponent(`#${discoverSearch}`);
    },
    isKeywordSearchEnabled: true
  },
  {
    value: 'storyTitles',
    label: 'Story Titles',
    searchPattern: (discoverSearch) => {
      return encodeURIComponent(`\\"${discoverSearch}\\"`);
    },
    isKeywordSearchEnabled: true,
    hoverMapDefaults: {
      displayFullLabelOnHover: true
    }
  },
  {
    value: 'domain',
    label: 'Domains',
    searchPattern: (discoverSearch) => {
      return `url:${discoverSearch}`;
    },
    isKeywordSearchEnabled: true,
    hoverMapDefaults: {
      displayFullLabelOnHover: true
    }
  }
];

const CATEGORY_VIEW_BY_OPTIONS = [
  {
    value: 'language',
    label: 'Language',
    // There were errors processing your request: is/has/lang cannot be used as a standalone operator (at position 1)
    searchPattern: null,
    isKeywordSearchEnabled: true
  },
  {
    value: 'platform',
    label: 'Platform',
    searchPattern: null,
    isKeywordSearchEnabled: true
  },
  {
    value: 'platform_hashtag',
    label: 'Platform Hashtag',
    searchPattern: null,
    isKeywordSearchEnabled: true
  },
  {
    value: 'country',
    label: 'Country',
    // Disabled by comment at ENG-6523
    // searchPattern: (discoverSearch) => {
    //   return `place:${discoverSearch}`;
    // },
    isKeywordSearchEnabled: false
  },
  {
    value: 'state',
    label: 'State',
    // Disabled by comment at ENG-6523
    // searchPattern: (discoverSearch) => {
    //   return `place:${discoverSearch}`;
    // },
    isKeywordSearchEnabled: false
  },
  {
    value: 'location',
    label: 'Location',
    isKeywordSearchEnabled: true,
    isProfileSearchEnabled: false
  },
  {
    // 10 is men, 30 is women and 0 is unknown
    value: 'gender',
    label: 'Gender',
    // No rule was found.
    searchPattern: null,
    isKeywordSearchEnabled: false,
    isAuthorData: true
  },
  {
    value: 'authorApplication',
    label: 'Author Application',
    // There were errors processing your request: Reference to invalid operator 'source'.
    // Operator is not available in current product or product packaging. Must be from the list:
    // [bounding_box, from, lang, point_radius, place, place_country, profile_region, profile_locality,
    // profile_country, profile_point_radius, retweets_of, to, url, has:hashtags, has:geo, has:images, has:links,
    // has:media, has:mentions, has:profile_geo, has:symbols, has:videos, is:retweet, is:verified, is:nullcast]
    // (at position 1)
    searchPattern: null,
    isKeywordSearchEnabled: false
  },
  {
    value: 'sentiment',
    label: 'Sentiment',
    // Zignal property.
    searchPattern: null,
    isKeywordSearchEnabled: false
  },
  {
    value: 'influenceScore',
    label: 'Influence Score',
    // Zignal property.
    searchPattern: null,
    isKeywordSearchEnabled: false,
    isAuthorData: true
  }
];

export const VIEW_BY_OPTIONS = {
  byCluster: CLUSTER_VIEW_BY_OPTIONS,
  byCategory: [...CLUSTER_VIEW_BY_OPTIONS, ...CATEGORY_VIEW_BY_OPTIONS],
  all: [...CLUSTER_VIEW_BY_OPTIONS, ...CATEGORY_VIEW_BY_OPTIONS]
};

export const CLUSTER_AUTHOR_VALUES = map(VIEW_BY_OPTIONS.all.filter(({isAuthorData}) => isAuthorData), 'value');

const magentaNode = '#FF00CA';
const yellowNode = '#F8E71B';
const cyanNode = '#57C4C4';
const orangeNode = '#FF8100';
const greyNode = 'grey';
const opaqueBlue = '#232E42';
export const COLORS = Object.assign({ magentaNode, yellowNode, cyanNode, orangeNode, greyNode, opaqueBlue }, colors);
export const AUTOMATION_COLOR_UNKNOWN = '#A5B3BD';
export const AUTOMATION_COLORS = [
  '#fefcff',
  '#e6c5f5',
  '#d692ec',
  '#bb2e8a',
  '#a60058'
];



// FIXME: remove `AUTHOR_TYPE_COLOR_MAP` when ENG-8436 is fully implemented.
export const AUTHOR_TYPE_COLOR_MAP = {
  humanToBot: cyanNode,
  botToHuman: yellowNode,
  botToBot: orangeNode,
  bot: magentaNode,
  human: COLORS.white01,
  unknown: greyNode
};
